import styled from "@emotion/styled";

export const Badge = styled.span`
  display: inline-block;
  padding: 0.5rem 1rem;
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border-radius: 0.25rem;
  color: #fff;
  background-color: #1B9AAA;
  margin: 0 1rem;
`;

// export const InputLabel = styled.div `
//   margin: 25px;
// `;

// export const Select = styled.div `
//  margin: 25px;
// `;

// export const FormControl = styled.div `
//   margin: 25px;
// `;